import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Detects whether the current URL indicates an auth flow in progress
 * (callback, silent-renew, sign-in, impersonation, OAuth code exchange).
 * Shared between customer and participant UIs.
 */
export function useIsAuthenticatingFlow(): boolean {
  const location = useLocation();

  return useMemo(() => {
    const pathname = location.pathname.toLowerCase();
    const search = location.search.toLowerCase();

    return (
      pathname.includes('/callback') ||
      pathname.includes('/silent-renew') ||
      pathname.includes('/signin') ||
      search.includes('impersonatetoken') ||
      search.includes('code=')
    );
  }, [location.pathname, location.search]);
}
